{
  "There were errors when trying to update: {{message}}": "There were errors when trying to update: {{message}}",
  "There were errors when trying to create: {{message}}": "There were errors when trying to create: {{message}}",
  "Type": "Type",
  "Title": "Title",
  "Teaser": "Teaser",
  "Space": "Space",
  "Content Owner": "Content Owner",
  "User visibility": "User visibility",
  "HIDDEN": "Hidden",
  "VISIBLE": "Visible",
  "FEATURED": "Featured",
  "StartTime": "Start time",
  "EndTime": "End time",
  "Address": "Location",
  "Url": "Url",
  "Room": "Room",
  "Capacity": "Capacity",
  "SEMINAR": "Seminar",
  "WEBINAR": "Webinar",
  "ARTICLE": "Article",
  "ONLINE_LEARNING": "On-demand learning",
  "E_LEARNING": "E-Learning",
  "LEARNING_PATH": "Learning Path",
  "items-from-another-space": "Collection still contains items from another space, you need to remove them before changing space:\n{{space}}",
  "remove-item-collection": "Are you sure that you want to remove this Learning from the collection?",
  "no-collection-items": "No learnings added to collection",
  "Edit Collection": "Edit Collection",
  "Category": "Category",
  "Select category": "Select category",
  "Subject": "Subject",
  "Please select a category": "Please select a category",
  "Language": "Language",
  "Save & exit": "Save & exit",
  "Create & exit": "Create & exit",
  "{{type}} saved successfully": "{{type}} saved successfully",
  "{{type}} archived successfully": "{{type}} archived successfully",
  "{{type}} deleted successfully": "{{type}} deleted successfully",
  "Teaser text": "Teaser text",
  "Participants": "Participants",
  "Teams": "Teams",
  "Variants": "Variants",
  "Select a format": "Select a format",
  "Digital": "Digital",
  "Classroom": "Classroom",
  "Blended": "Blended",
  "Institution": "Institution",
  "Instructors": "Learning Facilitators",
  "Level": "Level",
  "Select a Level": "Select a Level",
  "Basic": "Basic",
  "Intermediate": "Intermediate",
  "Advanced": "Advanced",
  "Select a Language": "Select a Language",
  "Select a Subject": "Select a Subject",
  "Total Effort": "Total Effort",
  "Global mandatory training": "Global mandatory training",
  "Compliance training credit": "Compliance training credit",
  "Approval required": "Activate approval",
  "Enroll button disabled": "Disable JOIN button",
  "Application form required": "Activate application form",
  "Confirmation message": "Confirmation message",
  "Social features enabled": "Enable Dicsussions",
  "Discussion section": "Discussion section",
  "Discussion section not matching format /abc, /abc/1:bar": "Discussion section not matching format /abc, /abc/1:bar",
  "create-section": "Create the section {{path}}/{{name}}?\nProduct will be saved.",
  "section-invalid-format": "Section not matching format /abc, /abc/1:bar",
  "Create and add section": "Create and add section",
  "Discussions root section": "Discussions root section",
  "Reflections enabled": "Enable Reflections",
  "Reflections section": "Reflections section",
  "Reflection section not matching format /abc, /abc/1:bar": "Reflection section not matching format /abc, /abc/1:bar",
  "Use default": "Use default",
  "Reflections": "Reflections",
  "Teams enabled": "Enabled teams",
  "confirm-disable-team": "Are you sure that you want to disable teams?\nThis will irreversibly delete any current team setup",
  "confirm-delete-learning-path": "Are you sure that you want to delete this learning path?",
  "Save changes": "Save changes",
  "Description": "Description",
  "Provider": "Partner",
  "Link ({{providerName}})": "Add link",
  "Does this Learning path use Learnifier?": "Does this Learning path use Learnifier?",
  "Choose partner {{applicable}}": "Choose partner {{applicable}}",
  "(if applicable)": "(if applicable)",
  "Select a Partner": "Select a Partner",
  "Choose provider": "Choose provider",
  "Select a Provider": "Select Provider",
  "Attach Learnifier": "Add Learnifier learning path",
  "Unable to load resource with id {{id}}": "Unable to load resource with id {{id}}",
  "Create resource": "Create resource",
  "Create {{type}}": "Create {{type}}",
  "Edit {{type}}": "Edit {{type}}",
  "Unable to load {{pageType}} with id {{id}}": "Unable to load {{pageType}} with id {{id}}",
  "Metadata": "Metadata",
  "Builder": "Builder",
  "Total effort in minutes": "Total effort in minutes",
  "Calculated effort": "Calculated effort",
  "If no linked video blocks have been used this calculation is accurate. For linked video blocks manually add the video duration.": "If no linked video blocks have been used this calculation is accurate. For linked video blocks manually add the video duration.",
  "Unable to calculate": "Unable to calculate",
  "linked-video": "{{count}} linked video",
  "linked-video_plural": "{{count}} linked videos",
  "Connected resources": "Connected resources",
  "Lead paragraph for the page": "Lead paragraph for the page",
  "Reading time": "Reading time",
  "Edit": "Edit",
  "Stop editing": "Save",
  "Are you sure you want to archive this {{pageType}}?": "Are you sure you want to archive this {{pageType}}?",
  "Are you sure you want to delete this {{pageType}}?": "Are you sure you want to delete this {{pageType}}? This is a permanent deletion and cannot be reversed.",
  "mark-participants-attended": "Mark {{total}} participants as attended?",
  "mark-participants-not-attended": "Mark {{total}} participants as not attended?",
  "participants-attendance-success": "Participants attendance updated",
  "participants-attendance-attended-empty-info": "Selected participants already attended",
  "participants-attendance-not-attended-empty-info": "Selected participants already not attending",
  "mark-attended": "Mark as attended",
  "mark-didnt-attend": "Mark as did not attended",
  "learners-selected": "{{count}} LEARNER SELECTED",
  "learners-selected_plural": "{{count}} LEARNERS SELECTED",
  "Caption": "Caption",
  "Text": "Text",
  "Select a video": "Select a video",
  "allowed-video-providers": "Only YouTube, Ted, Creo/Avalon One, Vimeo and Microsoft videos",
  "superadmin-embed-video": "Superadmin: Use any link you like (just make sure it's an embed URL)",
  "Audio/Podcast": "Audio/Podcast",
  "Resource": "Resource",
  "Video": "Video upload",
  "Video link": "Add video link",
  "Video caption for descriptive purposes": "Video caption for descriptive purposes",
  "Image caption for descriptive purposes": "Image caption for descriptive purposes",
  "Add new": "Add new",
  "contact support": "contact support",
  "video-error": "There was a problem with the video clip. Please remove this block and try uploading it again. If the problem persists please <1>contact support</1>.",
  "Transcoding": "Transcoding",
  "view": "view",
  "Image": "Image",
  "time": "time",
  "seat": "seat",
  "seat_plural": "seats",
  "left": "left",
  "Viewing time": "Viewing time",
  "no calculation needed": "no calculation needed",
  "no calculation possible": "no calculation possible",
  "Select type": "Select type",
  "Upload Video": "Upload Video",
  "Select Video": "Select Video",
  "Teaser text is used for the learning card and the learning page header": "Teaser text is used for the learning card and the learning page header",
  "Link not valid": "Link not valid",
  "No variant chosen": "No variant chosen",
  "Are you sure that you want to {{action}} this user?": "Are you sure that you want to {{action}} this user?",
  "approve": "approve",
  "reject": "reject",
  "remove": "remove",
  "Reject": "Reject",
  "Remove": "Remove",
  "Something went wrong with this order. Contact system admin about it.": "Something went wrong with this order. Contact system admin about it.",
  "Add participants": "Add participants",
  "Pick a session": "Pick a session",
  "Select session": "Select session",
  "Add session": "Add sessions",
  "Sessions": "Sessions",
  "email-notification-message": "The participants will be notified of their enrollment by email",
  "new-participants-added": "{{count}} new participant added to course",
  "new-participants-added_plural": "{{count}} new participants added to course",
  "email-could-not-be-added": "The following e-mail address could not be added to the course:",
  "email-could-not-be-added_plural": "The following e-mail addresses could not be added to the course:",
  "Participant list": "Participant list",
  "total-participants": "This course has a total of {{count}} participants",
  "total-participants_plural": "This course has a total of {{count}} participants",
  "participants-not-approved": " with {{count}} not yet approved",
  "Not a participant in the course": "Not a participant in the course",
  "Team setup": "Team setup",
  "setup-info": "Setup is based on available participants and tries to take into consideration a good spread based on user's realm.",
  "setup-info2": "The teamsize that you pick is locked in until, and if, you disable teams completely and start over.",
  "Pick teamsize:": "Pick teamsize:",
  "Old participants": "Old participants",
  "member-not-participating": "{{count}} team member not participating in the course.",
  "member-not-participating_plural": "{{count}} team members not participating in the course.",
  "remove-member": "Remove member",
  "remove-member_plural": "Remove members",
  "New participants": "New participants",
  "participants-without-team": "{{count}} participant without a team.",
  "participants-without-team_plural": "{{count}} participants without a team.",
  "Remove members not participating first.": "Remove members not participating first.",
  "add-member": "Add member to team",
  "add-member_plural": "Add members to team",
  "Too many team members": "Too many team members",
  "Free spot": "Free spot",
  "Go to module {{moduleId}}": "Go to module {{moduleId}}",
  "Go to page {{pageId}}": "Go to page {{pageId}}",
  "A visible collection makes all learning items within it visible, regardless of the individual item user setting.": "A visible collection makes all learning items within it visible, regardless of the individual item user setting.",
  "Add learnings": "Add learning items",
  "Learnings will be saved automatically when added or removed.": "Learning items will be saved automatically when added or removed.",
  "location-enroll-error": "An error occured when trying to enroll to this event",
  "Add learnings ({{count}} available)": "Add learnings ({{count}} available)",
  "Connected people": "Connected people",
  "Leave empty to have infinite seats": "Leave empty to have infinite seats",
  "Select a space": "Select a space",
  "Use custom button text": "Create new button text",
  "Custom button text": "New button text",
  "Button preview": "Button preview",
  "Archive": "Archive",
  "Restore learning": "Restore learning",
  "This learning has been archived.": "This learning has been archived.",
  "event-has-been_archived": "This event has been archived.",
  "event-has-been_ended": "This event has ended.",
  "Ended": "Ended",
  "Too many enrollments {{count}} available": "Too many enrollments. Available spots: {{count}}",
  "Enter e-mail addresses": "Enter e-mail addresses",
  "One e-mail address per row": "One e-mail address per row",
  "Add": "Add",
  "email": "email",
  "emails": "emails",
  "participant": "participant",
  "participants": "participants",
  "Content": "Content",
  "Attributes": "Attributes",
  "Filter attributes...": "Filter attributes...",
  "More information": "More information",
  "Event information": "Event information",
  "Additional connected people": "Contributors",
  "Subject Matter Expert": "Subject Matter Expert",
  "Moderator": "Moderator",
  "Learning facilitator": "Learning facilitator",
  "Role Responsible": "Role Responsible",
  "Subject Owner": "Subject Owner",
  "Select a role": "Select a role",
  "A person can only have one role": "A person can only have one role",
  "Upload an exported HTML5 E-Learning bundle": "Upload an E-Learning package",
  "No unsaved changes.": "No unsaved changes.",
  "Changes have not been saved.": "Changes have not been saved.",
  "You have unsaved changes.\n Are you sure that you want to leave?": "You have unsaved changes.\n Are you sure that you want to leave?",
  "Missing required field(s).": "Missing required field(s).",
  "missing-required-field": "Missing one required field: {{item}}.",
  "missing-required-field_plural": "Missing $t({{count}}, {\"count\": {{count}}, \"ns\": \"common\" }) required fields: {{item}}.",
  "Add block": "Add block",
  "You have an empty block added.": "You have an empty block added.",
  "Link URL": "Link URL",
  "Link text": "Link text",
  "max-participant-batch": "You can only add {{max}} participants at a time.",
  "Last edited by": "Last edited by",
  "Created by": "Created by",
  "completion-status-has-been-set": "Completion status has been set",
  "attended": "Attended",
  "didn't-attend": "Didn't Attend",
  "learnings-reset-space": "The selected learnings were reset because space was changed",
  "Participant email": "Participant email",
  "Send invite": "Send invite",
  "Add group": "Add group",
  "Add emails information": "Paste one or multiple email addresses, one per row",
  "Enrolled": "Enrolled",
  "Attended": "Attended",
  "In waitlist": "In waitlist",
  "Did not attend": "Did not attend",
  "Waiting list": "Waiting list",
  "waitlist-disable-clear-waitlisted-users-message": "Disabling the waiting list will remove any waitlisted users from this session",
  "imparta-invalid-object-id": "Unrecognized Imparta course URL. Expected links like \"https://iportal-integration.azurewebsites.net/Home/Resources?CourseProgramme=23469\" \n\nYou can continue, but no learning progress will be captured for this learning path",
  "pluralsight-invalid-object-id": "Unrecognized Pluralsight course URL. Expected links like \"https://app.pluralsight.com/library/courses/8ae31d47-b224-405a-ad2f-e6de581ceab9\" \n\nYou can continue, but no learning progress will be captured for this learning path.",
  "object-urn": "Object URN (superadmins only)"
}
